"use strict";

var React = require("react");

var SvgIconSearch24Px = function SvgIconSearch24Px() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 10 10",
    },
    /*#__PURE__*/ React.createElement("path", {
      d:
        "M7.148 6.289h-.454l-.158-.157c.558-.65.897-1.492.897-2.416a3.716 3.716 0 10-1.3 2.821l.157.157v.453L9.148 10 10 9.148l-2.852-2.86zm-3.432 0a2.572 2.572 0 110-5.145 2.572 2.572 0 010 5.145z",
      fill: "currentColor",
    })
  );
};

exports["foreignIcon"] = SvgIconSearch24Px;
